import { Expose } from 'class-transformer';

export default class EditJobError {
  start_time: string[] = []
  end_time: string[] = []
  lunch_break: string[] = []
  headcount: string[] = []
  description: string[] = []
  hygienist_required: string[] = []
  sedation_required: string[] = []
  radiography_required: string[] = []
  implant_required: string[] = []
  orthodontics_required: string[] = []
  nurse_preference: string[] = []
  preferred_nurses_wait_until: string[] = []
  parking: string[] = []
  hygienist_support: string[] = []
  dental_nurse_bonus_rate: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}